/**
 * Русское склонение при числе.
 *
 * «1 задача», «2 задачи», «5 задач» — правило одно и то же для всех
 * существительных, поэтому оно живёт здесь, а не переписывается на каждом экране.
 */

const TEENS_START = 11;
const TEENS_END = 14;
const FEW_START = 2;
const FEW_END = 4;

export function plural(count: number, one: string, few: string, many: string): string {
  const absolute = Math.abs(count) % 100;
  // 11–14 всегда «задач», хотя оканчиваются на 1, 2, 3, 4
  if (absolute >= TEENS_START && absolute <= TEENS_END) {
    return many;
  }
  const last = absolute % 10;
  if (last === 1) {
    return one;
  }
  return last >= FEW_START && last <= FEW_END ? few : many;
}

/** Число вместе со склонённым словом: «3 задачи». */
export function counted(count: number, one: string, few: string, many: string): string {
  return `${String(count)} ${plural(count, one, few, many)}`;
}
